import { NgModule } from '@angular/core';
import { AgGridModule } from 'ag-grid-angular';
import { SharedModule } from '@approot/shared/shared.module';
import { TreasuryCurvesComponent } from './treasury-curves/treasury-curves.component';
import { scheduleReportsComponent } from './schedule-reports/schedule-reports.component';
import { EntitiesComponent } from './entities/entities.component';
import { CsaComponent } from './csa/csa.component';
import { CreditCurvesComponent } from './credit-curves/credit-curves.component';
import { ScheduleReportsParametersComponent } from './schedule-reports/schedule-reports-parameters/schedule-reports-parameters.component';
import { AlertsComponent } from './alerts/alerts.component';
import { AlertsParametersComponent } from './alerts/alerts-parameters/alerts-parameters.component';
import { LoadScheduledReportComponent } from './schedule-reports/load-scheduled-report/load-scheduled-report.component';
import { SubAccountsComponent } from './entities/sub-accounts/sub-accounts.component';

@NgModule({
  declarations: [
    TreasuryCurvesComponent,
    scheduleReportsComponent,
    EntitiesComponent,
    CsaComponent,
    CreditCurvesComponent,
    ScheduleReportsParametersComponent,
    AlertsComponent,
    AlertsParametersComponent,
    LoadScheduledReportComponent,
    SubAccountsComponent
  ],
  imports: [SharedModule, AgGridModule],
  exports: [
    TreasuryCurvesComponent,
    scheduleReportsComponent,
    EntitiesComponent,
    CsaComponent,
    CreditCurvesComponent,
    AlertsComponent
  ]
})
export class TradeCaptureModule {}
